export interface ILanguageOption {
  code: string;
  label: string;
  /** Path to the flag image under `public/images/flags` (rendered as an `<img>`, not an emoji). */
  flag: string;
}

export const CUSTOMER_LANGUAGES: ILanguageOption[] = [
  { code: "en", label: "English", flag: "/images/flags/en.png" },
  { code: "it", label: "Italiano", flag: "/images/flags/it.png" },
  { code: "fr", label: "Français", flag: "/images/flags/fr.svg" },
  { code: "de", label: "Deutsch", flag: "/images/flags/de.svg" },
  { code: "es", label: "Español", flag: "/images/flags/es.svg" },
  { code: "ar", label: "العربية", flag: "/images/flags/ar.svg" },
  { code: "zh", label: "中文", flag: "/images/flags/zh.svg" },
];

export const CUSTOMER_LANGUAGE_CODES = CUSTOMER_LANGUAGES.map(l => l.code);
